/* Piranjas Bundle Add-to-Cart
 * Ein Button mit data-bundle-add="variantId1,variantId2,..." legt alle
 * genannten Varianten gleichzeitig in den Warenkorb (AJAX).
 * Wird von custom-food-pairing und custom-basket-builder genutzt.
 */
(function () {
  'use strict';
  if (window.__piranjaBundleInit) return;
  window.__piranjaBundleInit = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
    ? window.Shopify.routes.root : '/';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bundle-add]');
    if (!btn) return;
    e.preventDefault();

    var ids = (btn.dataset.bundleAdd || '').split(',').filter(Boolean);
    if (!ids.length) return;

    var items = ids.map(function (id) { return { id: Number(id), quantity: 1 }; });
    var label = btn.textContent;
    btn.disabled = true;

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      var n = document.querySelector('cart-notification, cart-drawer');
      if (n && typeof n.open === 'function') { n.open(); }
      btn.classList.add('is-success');
      btn.textContent = '✓ Hinzugefügt';
      setTimeout(function () {
        btn.classList.remove('is-success');
        btn.textContent = label;
        btn.disabled = false;
      }, 1600);
    }).catch(function () {
      btn.disabled = false;
      alert('Konnte nicht zum Warenkorb hinzugefügt werden.');
    });
  });
})();
